import type { RespostasPersonalizadasIzzaModel } from "../models/respostasPersonalizadasIzzaModel"
import { RespostasPersonalizadasIzzaInicial } from "../models/respostasPersonalizadasIzzaModel"
import type { RespostasPersonalizadasIzzaActionModel } from "./respostasPersonalizadasIzzaActions"
import { RespostasPersonalizadasIzzaActionsTypes } from "./respostasPersonalizadasIzzaActions"

export function respostasPersonalizadasIzzaReducer(
    state: RespostasPersonalizadasIzzaModel = RespostasPersonalizadasIzzaInicial,
    action: RespostasPersonalizadasIzzaActionModel
): RespostasPersonalizadasIzzaModel {
    switch (action.type) {
        case RespostasPersonalizadasIzzaActionsTypes.CARREGAR:
            return { ...action.payload }

        case RespostasPersonalizadasIzzaActionsTypes.ATUALIZAR_RESPOSTA:
            return {
                ...state,
                [action.payload.campo]: {
                    ...state[action.payload.campo],
                    resposta: action.payload.resposta,
                },
            }

        case RespostasPersonalizadasIzzaActionsTypes.TOGGLE_ATIVO:
            return {
                ...state,
                [action.payload.campo]: {
                    ...state[action.payload.campo],
                    ativo: !state[action.payload.campo].ativo,
                },
            }

        case RespostasPersonalizadasIzzaActionsTypes.TOGGLE_AVALIACAO:
            return {
                ...state,
                enviarMensagemDeAvaliacaoPedidoPelaIzza: !state.enviarMensagemDeAvaliacaoPedidoPelaIzza,
            }

        case RespostasPersonalizadasIzzaActionsTypes.SET_MODO_IZZA:
            return {
                ...state,
                modoIzza: action.payload.modoIzza,
            }

        case RespostasPersonalizadasIzzaActionsTypes.TOGGLE_INDICACAO:
            return {
                ...state,
                bonificarIndicacaoAmigos: !state.bonificarIndicacaoAmigos,
            }

        case RespostasPersonalizadasIzzaActionsTypes.SET_TEXTO_INDICACAO:
            return {
                ...state,
                textoPromocaoIndicacao: action.payload.texto,
            }

        default:
            return state
    }
}
